module.exports = "<div class=\"loading-mask\"></div>"


//////////////////
// WEBPACK FOOTER
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-beta/src/app/components/logout/logout.html
// module id = ../../../../../src/app/components/logout/logout.html
// module chunks = 1